import * as THREE from 'three';
import AddObjectAction, { IAddObjectData } from './AddObjectAction';
import SetObjectParentAction, { ISetObjectParentData } from './SetObjectParentAction';
import Action from "../classes/Action";

export default class ParentToNewEmptyAction extends Action
{

	private emptyParentParams?: ISetObjectParentData;

	constructor(objects: THREE.Object3D[], emptyObject: THREE.Object3D, parent?: THREE.Object3D)
	{
		const actionName = `Parented ${objects.length} object${objects.length === 1 ? "" : "s"} to new empty`;
		const addObject = AddObjectAction.createAddObjectData(emptyObject);
		const setParent = SetObjectParentAction.createSetObjectParentData(objects, emptyObject);
		super([addObject, setParent, parent], [addObject, setParent], actionName, [addObject, setParent]);
	}

	do(addObjectParams: IAddObjectData, setParentParams: ISetObjectParentData, parent?: THREE.Object3D)
	{
		AddObjectAction.doFunction(addObjectParams.object, addObjectParams.parent);
		SetObjectParentAction.doFunction(setParentParams.objects, setParentParams.orderChangeObjects, setParentParams.parentChangeObjects, setParentParams.newParent, setParentParams.atIndex);
		if (parent)
		{
			this.emptyParentParams = SetObjectParentAction.createSetObjectParentData([addObjectParams.object], parent);
			SetObjectParentAction.doFunction(this.emptyParentParams.objects, this.emptyParentParams.orderChangeObjects, this.emptyParentParams.parentChangeObjects, this.emptyParentParams.newParent, this.emptyParentParams.atIndex);
		}
	}

	undo(addObjectParams: IAddObjectData, setParentParams: ISetObjectParentData)
	{
		if (this.emptyParentParams)
		{
			SetObjectParentAction.undoFunction(this.emptyParentParams.objectParentMap);
		}
		SetObjectParentAction.undoFunction(setParentParams.objectParentMap);
		AddObjectAction.undoFunction(addObjectParams.object, addObjectParams.previousSelection);
	}

	verify(addObjectParams: IAddObjectData, setParentParams: ISetObjectParentData): boolean 
	{
		return SetObjectParentAction.verifyFunction(setParentParams.objects, setParentParams.orderChangeObjects, setParentParams.parentChangeObjects, setParentParams.atIndex) &&
			(this.emptyParentParams ? SetObjectParentAction.verifyFunction(this.emptyParentParams.objects, this.emptyParentParams.orderChangeObjects, this.emptyParentParams.parentChangeObjects, this.emptyParentParams.atIndex) : true);
	}
}
